import { ApiBase } from './api-base';

export class FanRequestsApi extends ApiBase {
  model = 'fanRequests';
  getFanRequestBase(params?: {
      fanRequestBaseId?: string;
    }) {
      return this.http.get<any>(`${this.modelBase}`,{
        params: this.setParams(params)
      })
    }
}
